import React from "react";
import { useTranslation } from "react-i18next";
import { Box, IconButton, Stack, useTheme } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import Button from "components/basic/button";
import Typography from "components/basic/typography";

import { Meeting } from "../../../../types";

interface ConfirmedLinkActionsProps {
  meeting: Meeting;
  onReschedule: () => void;
  onCancel: () => void;
}

const ConfirmedLinkActions: React.FC<ConfirmedLinkActionsProps> = ({
  meeting,
  onReschedule,
  onCancel,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("meetings");

  return (
    <Box sx={{ mb: 2 }}>
      {meeting.meetingLink ? (
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 1,
            p: 1,
          }}
        >
          <LinkIcon fontSize="small" color="action" />
          <Typography
            variant="body2"
            style={{ flex: 1, wordBreak: "break-all" }}
          >
            {meeting.meetingLink}
          </Typography>
          <IconButton
            size="small"
            title={t("link_actions.copy")}
            onClick={() =>
              navigator.clipboard?.writeText(meeting.meetingLink ?? "")
            }
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Stack>
      ) : null}
      <Stack direction="row" spacing={1.5} sx={{ mt: 2 }}>
        <Button variant="outlined" color="warning" onClick={onReschedule}>
          {t("link_actions.reschedule")}
        </Button>
        <Button variant="outlined" color="error" onClick={onCancel}>
          {t("link_actions.cancel")}
        </Button>
      </Stack>
    </Box>
  );
};

export default ConfirmedLinkActions;
